// Menú lateral. Cada ítem tiene:
//  - menu: permiso que decide si el rol ve el ítem (se asigna en Roles y Usuarios).
//  - requiere: permiso de acción que la pantalla necesita para funcionar.
// El ítem se muestra solo si el usuario tiene ambos.
// Los permisos "menu.*" deben existir también en App\Support\Permisos::MENUS (backend).
const SOLICITUDES = ["solicitudes-gasto.crear", "solicitudes-gasto.aprobar"];

export const MENU = [
  {
    titulo: "DASHBOARD",
    items: [
      { to: "/dashboard", titulo: "Matrículas", icono: "mdi-chart-box-outline", menu: "menu.dashboard-matriculas", requiere: "dashboard.ver" },
      { to: "/dashboard/alumnos", titulo: "Alumnos", icono: "mdi-account-school-outline", menu: "menu.dashboard-alumnos", requiere: "dashboard.ver" },
      { to: "/dashboard/financiero", titulo: "Financiero", icono: "mdi-cash-multiple", menu: "menu.dashboard-financiero", requiere: "dashboard.ver" },
      { to: "/dashboard/combustible", titulo: "Combustible", icono: "mdi-gas-station-outline", menu: "menu.dashboard-combustible", requiere: "dashboard.ver" },
    ],
  },
  {
    titulo: "ACADEMIA",
    items: [
      { to: "/calendario", titulo: "Calendario", icono: "mdi-calendar", menu: "menu.calendario", requiere: "calendario.ver" },
      { to: "/alumnos", titulo: "Alumnos", icono: "mdi-account-school", menu: "menu.alumnos", requiere: "alumnos.ver" },
      { to: "/cotizaciones", titulo: "Cotizaciones", icono: "mdi-file-edit-outline", menu: "menu.cotizaciones", requiere: "cotizaciones.gestionar" },
    ],
  },
  {
    titulo: "CATÁLOGOS",
    items: [
      { to: "/catalogos/paquetes", titulo: "Paquetes y precios", icono: "mdi-tag-multiple-outline", menu: "menu.paquetes", requiere: "catalogos.gestionar" },
    ],
  },
  {
    titulo: "INGRESOS",
    items: [
      { to: "/ingresos", titulo: "Ingresos", icono: "mdi-cash-plus", menu: "menu.ingresos", requiere: "ingresos.gestionar" },
    ],
  },
  {
    titulo: "GASTOS",
    items: [
      { to: "/gastos", titulo: "Gastos", icono: "mdi-cash-minus", menu: "menu.gastos", requiere: "gastos.gestionar" },
      {
        to: "/gastos/solicitudes",
        titulo: "Solicitudes de Gasto",
        icono: "mdi-file-document-check-outline",
        menu: "menu.solicitudes-gasto",
        requiere: SOLICITUDES,
        badge: "solicitudesPendientes",
      },
      { to: "/gastos/combustible", titulo: "Combustible", icono: "mdi-gas-station", menu: "menu.combustible", requiere: "gastos.gestionar" },
    ],
  },
  {
    titulo: "REPORTES",
    items: [
      { to: "/reportes/ingresos", titulo: "Ingresos", icono: "mdi-cash-plus", menu: "menu.reporte-ingresos", requiere: "reportes.ver" },
      { to: "/reportes/gastos", titulo: "Gastos", icono: "mdi-receipt-text-outline", menu: "menu.reporte-gastos", requiere: "reportes.ver" },
      { to: "/reportes/flujo", titulo: "Flujo", icono: "mdi-swap-vertical-bold", menu: "menu.reporte-flujo", requiere: "reportes.ver" },
    ],
  },
  {
    titulo: "SEGURIDAD",
    items: [
      { to: "/seguridad/roles", titulo: "Roles y Usuarios", icono: "mdi-shield-account", menu: "menu.roles", requiere: "roles.gestionar" },
    ],
  },
];

export const ITEMS_MENU = MENU.flatMap((seccion) => seccion.items);

// Secciones de la app móvil (marc_movil, HomeScreen.kt). Aquí solo se usan para
// configurarlas por rol; los permisos "movil.*" deben existir en App\Support\Permisos (backend).
export const MENU_MOVIL = {
  titulo: "APP MÓVIL",
  items: [
    { titulo: "Agenda", menu: "movil.agenda", requiere: "calendario.ver" },
    { titulo: "Programar", menu: "movil.programar", requiere: "programacion.gestionar" },
    { titulo: "Alumnos", menu: "movil.alumnos", requiere: "alumnos.ver" },
    { titulo: "Dashboard", menu: "movil.dashboard", requiere: "dashboard.ver" },
    { titulo: "Solicitudes de Gasto", menu: "movil.gastos", requiere: SOLICITUDES },
  ],
};

// `requerido` puede ser un permiso o una lista (basta con tener uno).
export function tienePermiso(permisos, requerido) {
  if (!requerido) return true;
  const lista = Array.isArray(requerido) ? requerido : [requerido];
  return lista.some((p) => (permisos || []).includes(p));
}

export function puedeVerItem(permisos, item) {
  return tienePermiso(permisos, item.menu) && tienePermiso(permisos, item.requiere);
}

// Una ruta que es ítem del menú exige el permiso del menú; todas exigen su meta.permiso.
export function puedeEntrar(permisos, ruta) {
  const item = ITEMS_MENU.find((i) => i.to === ruta.path);
  if (item && !puedeVerItem(permisos, item)) return false;
  return tienePermiso(permisos, ruta.meta.permiso);
}
